export const USER = 'user';
export const ADVAIT_HMI = 'ADVAIT_HMI';
export const SEVERITY_ERROR = 'error';
export const DASHBOARD_EDITOR = 'DASHBOARD_EDITOR';
export const MACHINE_SR_NO = 'MACHINE_SR_NO';
export const liscenseExpired = 'LISCENSE_EXPIRED';
export const APCM='APCM';

export const ERROR_MESSAGES = {
    400: 'Bad Request: Your request cannot be processed.',
    401: 'Your session is expired. Please login again!',
    403: 'Something went wrong',
    404: 'Not Found: The requested resource could not be found on the server.',
    405: 'Something went wrong',
    429: "You've made too many requests. Please wait a bit before trying again.",
    500: 'Something went wrong',
    502: 'Something went wrong',
    503: 'Service unavailable',
    504: 'Gateway Timeout: Please try again later',
};
